import { Card } from 'antd';
import { Button } from '@bancobarigui/barihaus';
import {
  FileTextOutlined,
  EyeOutlined,
  CheckCircleOutlined,
  ToolOutlined,
} from '@ant-design/icons';
import { InspectionReport } from '@/services/inspectionReport.service';
import { InspectionReportReview } from '@/shared/types/inspectionReportReview.types';
import { formatDate, formatFileSize } from '../../utils';

interface ReportCardProps {
  report: InspectionReport;
  isInspector: boolean;
  isProvider: boolean;
  isBank: boolean;
  pendingReview: InspectionReportReview | null;
  inspectorCanCreateOrEdit: boolean;
  isRejectedByBank: boolean;
  canReview: boolean;
  onView: () => void;
  onReview: () => void;
  onCorrect: () => void;
  onEdit?: () => void;
  showEditButton?: boolean;
}
export function ReportCard({
  report,
  isInspector,
  pendingReview,
  inspectorCanCreateOrEdit,
  isRejectedByBank,
  canReview,
  onView,
  onReview,
  onCorrect,
  onEdit,
  showEditButton,
}: ReportCardProps) {
  return (
    <Card
      className="shadow-sm"
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <FileTextOutlined style={{ color: '#1890ff' }} />
          <span>Laudo Atual</span>
        </div>
      }
    >
      <div
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
      >
        <div style={{ flex: 1 }}>
          <div
            style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}
          >
            <h4 style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>
              {report.fileName}
            </h4>
          </div>
          <div style={{ display: 'flex', gap: 16, fontSize: 13, color: '#666' }}>
            <span>Tamanho: {formatFileSize(report.fileSize)}</span>
            <span>•</span>
            <span>Criado em: {formatDate(report.createdAt)}</span>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          {isInspector &&
            pendingReview &&
            inspectorCanCreateOrEdit &&
            !isRejectedByBank && (
              <Button
                type="default"
                icon={<ToolOutlined />}
                onClick={onCorrect}
              >
                Corrigir Checklist
              </Button>
            )}

          {showEditButton && onEdit && (
            <Button
              buttonColor="primary"
              icon={<ToolOutlined />}
              onClick={onEdit}
            >
              Revisar e Transmitir Laudo
            </Button>
          )}
          {canReview && !showEditButton && (
            <Button
              type="default"
              icon={<CheckCircleOutlined />}
              onClick={onReview}
              style={{ borderColor: '#52c41a', color: '#52c41a' }}
            >
              Avaliar Laudo
            </Button>
          )}
          <Button
            type={pendingReview && isInspector ? 'default' : 'primary'}
            icon={<EyeOutlined />}
            onClick={onView}
          >
            Visualizar
          </Button>
        </div>
      </div>

      {isInspector &&
        pendingReview?.generalComments &&
        inspectorCanCreateOrEdit &&
        !isRejectedByBank && (
          <div
            style={{
              marginTop: 12,
              padding: '10px 0px',
              borderRadius: 6,
              maxWidth: 500,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
              <span style={{ fontSize: 14, fontWeight: 600 }}>
                Comentários da Revisão:
              </span>
            </div>
            <p style={{ margin: 0, fontSize: 13, lineHeight: 1.5 }}>
              {pendingReview.generalComments}
            </p>
          </div>
        )}
    </Card>
  );
}
